module.exports = __webpack_public_path__ + "img/img18.26464f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/01/img18.png
// module id = 173
// module chunks = 0